import { useEffect, useState } from 'react';

import './AlertsCard.css';

import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Spinner from 'components/Spinner';
import AlertsList from 'components/AlertsList';
import {
	// addPropertyToPortfolio,
	// fetchPortfolio,
	getIsPropertyInPortfolio,
} from 'reducers/portfolioReducer';

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

function AlertsCard() {
	const dispatch = useDispatch();
	const {
		isLoggedIn,
		propertyData,
		propertyInPortfolio,
		isLoading,
		isLoadingIsPropertyInPortfolio,
	} = useSelector((state) => ({
		isLoggedIn: !!state.user.userData?.id,
		propertyData: state.property.propertyData,
		propertyInPortfolio: state.portfolio.propertyInPortfolio,
		isLoading:
			state.portfolio.isLoading ||
			state.portfolio.isLoadingIsPropertyInPortfolio,
		isLoadingIsPropertyInPortfolio:
			state.portfolio.isLoadingIsPropertyInPortfolio,
	}));

	const isPropertyInPortfolio =
		!!propertyInPortfolio &&
		(propertyInPortfolio?.id || propertyInPortfolio) === propertyData?.id;
	const [currentPropId, setCurrentPropId] = useState(null);

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		if (isLoggedIn && propertyData?.id && propertyData.id !== currentPropId) {
			setCurrentPropId(propertyData?.id);
			if (!isLoadingIsPropertyInPortfolio) {
				dispatch(getIsPropertyInPortfolio(propertyData.id));
			}
		}
	}, [isLoggedIn, propertyData?.id]);

	let content = (
		<Link className="btn-get-alerts" to={`/sign-in`}>
			Sign Up To Get Alerts
		</Link>
	);

	if (isLoading) {
		content = <Spinner />;
	} else if (!isLoggedIn) {
		content = (
			<Link className="btn-get-alerts" to={`/sign-in`}>
				Sign Up To Get Alerts
			</Link>
		);
	} else if (isPropertyInPortfolio) {
		content = <AlertsList />;
	} else {
		content = (
			<button
				className="btn-get-alerts"
				onClick={() =>
					dispatch(
						openModal(MODAL_TYPES.PROPERTY_NOTIFICATION_MODAL, {
							property: propertyData,
						})
					)
				}
			>
				Sign Up To Get Alerts
			</button>
		);
	}

	return (
		<div className={`overview-card-alerts ${isPropertyInPortfolio ? 'has-alerts-list' : ''}`}>
			<h2 className="alerts-card-title">Alerts and Notifications</h2>
			<div className="alerts-card-body">{content}</div>
		</div>
	);
}

export default AlertsCard;
